const authenticateDetail = {
  data: {
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhZ2VuY3lfbWlncmF0aW9uX2lkIjoyNzc5LCJpYXQiOjE2MjI2MzUzODQsImV4cCI6MTYyMjcyMTc4NH0.giADIkSaw0hh4b29BWEvGJwMWJf02QySe4_lnwWPaCw'
  }
}

export default authenticateDetail;
